import { getOgAdContext } from './environment-utils';

export function isSupplyMonitoringEventsEnabled(formatConfig: {
  isOgurySdk: boolean;
}) {
  if (getOgAdContext().enable_supply_monitoring_events) return true;
  return !formatConfig.isOgurySdk;
}
